/* tslint:disable */
/* eslint-disable */
/**
 * Megasense data portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Pollution data for the given pollutant
 * @export
 * @interface PollutionEntry
 */
export interface PollutionEntry {
    /**
     * 
     * @type {string}
     * @memberof PollutionEntry
     */
    pollutantId?: string;
    /**
     * 
     * @type {number}
     * @memberof PollutionEntry
     */
    value?: number;
}

export function PollutionEntryFromJSON(json: any): PollutionEntry {
    return PollutionEntryFromJSONTyped(json, false);
}

export function PollutionEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PollutionEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pollutantId': !exists(json, 'pollutantId') ? undefined : json['pollutantId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function PollutionEntryToJSON(value?: PollutionEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pollutantId': value.pollutantId,
        'value': value.value,
    };
}


